export default __webpack_public_path__ + "static/media/familyHome.6d617bad.png";